import { BlockContentValue } from "@silversea-ssc/ui-components-react";
import TextBox from "components/TextBox/TextBox";
import React from "react";
import * as styles from "./FareCardDisclaimer.module.scss";

type Props = {
  content?: BlockContentValue;
};

const FareCardDisclaimer: React.FC<Props> = ({ content }) => {
  if (!content) return null;

  return (
    <TextBox
      content={content}
      fontSize="inherit"
      className={styles.disclaimerText}
    />
  );
};

export default FareCardDisclaimer;
